import { render } from "./McpServers.vue?vue&type=template&id=9f7a9b94&scoped=true"
import script from "./McpServers.vue?vue&type=script&lang=js"
export * from "./McpServers.vue?vue&type=script&lang=js"

import "./McpServers.vue?vue&type=style&index=0&id=9f7a9b94&scoped=true&lang=css"
import "./McpServers.vue?vue&type=style&index=1&id=9f7a9b94&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f7a9b94"]])

export default __exports__